import SelectLocationTypeApp from './select-location-type-app'

export default SelectLocationTypeApp
